import projectFoldersSettingsComponent from './project-folders-settings.component';

const projectFoldersSettingsModule = angular.module('projectFoldersSettings', [
])
  .component('projectFoldersSettings', projectFoldersSettingsComponent)
  .name;

export default projectFoldersSettingsModule;
